import React from 'react';
import { Tooltip } from '@material-ui/core';
import { Check } from '@material-ui/icons';

const CheckIcon = ({
	onClick,
	value,
	tooltip = 'Aceptar',
	colorName = '',
	className,
}) => {
	return (
		<Tooltip title={tooltip} onClick={onClick}>
			<Check style={{ color: colorName }} className={className} />
		</Tooltip>
	);
};

export default CheckIcon;
